/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConsultationStrictHttpResponse } from '../../consultation-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterStatusUpdateModel } from '../../models/encounter-status-update-model';

export interface EncounterUpdateStatusPost$Params {
      body?: EncounterStatusUpdateModel
}

export function encounterUpdateStatusPost(http: HttpClient, rootUrl: string, params?: EncounterUpdateStatusPost$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, encounterUpdateStatusPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ConsultationStrictHttpResponse<string>;
    })
  );
}

encounterUpdateStatusPost.PATH = '/Encounter/UpdateStatus';
